export default "__VITE_ASSET__DZjKJztO__"